import { useEffect, useState } from 'react'
import {
  getTimerNotificationsEnabled,
  setTimerNotificationsEnabled,
  subscribeToTimerNotifications,
} from '../utils/timer-notifications-preference'

export function useTimerNotificationsEnabled(): [boolean, (next: boolean) => void] {
  const [enabled, setEnabled] = useState<boolean>(() => getTimerNotificationsEnabled())

  useEffect(() => subscribeToTimerNotifications(setEnabled), [])

  return [enabled, setTimerNotificationsEnabled]
}
